import type {ManifestationStatus} from 'api/types';
import {useAppSelector} from 'store/hooks';
import {selectMetadataEditStatuses} from '../metadataEditSlice';

export const useAggregatedStatus = (id: string): ManifestationStatus => {
  return useAppSelector(selectMetadataEditStatuses)[id]?.status ?? 'NEW';
};
